export default __webpack_public_path__ + "images/assets/f144dda9f1382c2dd10fa4b70e952211.svg";